import { isUuid } from '../../../js/app/react/validators';
import { useRouteParams } from './useRouteParams';
import { useProposedPlansQuery } from '../api/useProposedPlansQuery';
import { useLocalStorageKey } from './useLocalStorageKey';

// default to first plan if nothing is stored in local storage
export const useSelectedPlan = () => {
  const { data } = useProposedPlansQuery();

  const { clientId } = useRouteParams();

  const localStorageKey = useLocalStorageKey();

  const { PrintArea, ConsumerArea } = window.ADV.store.getState();

  if (!data) {
    return null;
  }

  if (clientId) {
    const fpId = localStorage.getItem(localStorageKey);

    if (isUuid(fpId)) {
      return data.find(({ planId }) => planId === fpId) ?? data[0];
    }
  }

  if (PrintArea && isUuid(PrintArea.fpId)) {
    return data.find(({ planId }) => planId === PrintArea.fpId) ?? data[0];
  }

  if (ConsumerArea && isUuid(ConsumerArea.fpId)) {
    return data.find(({ planId }) => planId === ConsumerArea.fpId) ?? data[0];
  }

  return data[0];
};
